import React from "react";

export const HexCheckIconSmall = () => {
  return (
    <svg
      width="8"
      height="7"
      viewBox="0 0 8 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={"c-hex-checkbox-check-small"}
    >
      <path
        d="M1.22437 2.02678L4.21444 4.97527L2.99007 6.18262L0 3.23412L1.22437 2.02678Z"
        fill="white"
      />
      <path
        d="M8 1.24289L2.99007 6.18262L1.91516 5.12257L6.92477 0.182617L8 1.24289Z"
        fill="white"
      />
    </svg>
  );
};
